import { createSlice } from "@reduxjs/toolkit";
import {
  GetDataCenter, // ✅ Fixed: Corrected from getSingleServer
  blockDataCenter,
  getAllDataCenter,
  saveDataCenter,
  updateDataCenter, // ✅ Fixed: Corrected from updateServer
} from "../actions/DataCenter";

const initialState = {
  servers: [],
  singleServer: null,
  loading: false,
  error: null,
  totalCount:0,
};

const DataCenterSlice = createSlice({
    name: "data=center",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        // Get Single Server
        .addCase(GetDataCenter.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GetDataCenter.fulfilled, (state, action) => {
          state.loading = false;
          state.singleServer = action.payload;
        })
        .addCase(GetDataCenter.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Save New Server
        .addCase(saveDataCenter.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(saveDataCenter.fulfilled, (state, action) => {
          state.loading = false;
          state.servers.push(action.payload);
        })
        .addCase(saveDataCenter.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Get All Servers
        .addCase(getAllDataCenter.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getAllDataCenter.fulfilled, (state, action) => {
          const { result, totalDocument } = action.payload;
          state.servers = result;
          state.totalCount = totalDocument;
          state.loading = false;
        })
        .addCase(getAllDataCenter.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Update Server
        .addCase(updateDataCenter.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateDataCenter.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, ...action.payload } : server
          );
        })
        .addCase(updateDataCenter.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Block Server
        .addCase(blockDataCenter.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(blockDataCenter.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, blocked: true } : server
          );
        })
        .addCase(blockDataCenter.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  

export default DataCenterSlice.reducer;
